import { useEffect } from "react";

/**
 * Pin the document to a fixed capture frame (OBS Browser Source / prototype popup size),
 * restoring the previous page sizing on unmount.
 */
export function useCaptureFrameViewport(width, height) {
    useEffect(() => {
        const html = document.documentElement;
        const body = document.body;
        const root = document.getElementById("root");
        const prev = {
            htmlOverflow: html.style.overflow,
            bodyOverflow: body.style.overflow,
            htmlW: html.style.width,
            htmlH: html.style.height,
            bodyW: body.style.width,
            bodyH: body.style.height,
            bodyMargin: body.style.margin,
            rootW: root?.style.width,
            rootH: root?.style.height,
            rootOverflow: root?.style.overflow,
        };
        html.style.overflow = "hidden";
        body.style.overflow = "hidden";
        html.style.width = `${width}px`;
        html.style.height = `${height}px`;
        body.style.width = `${width}px`;
        body.style.height = `${height}px`;
        body.style.margin = "0";
        if (root) {
            root.style.width = `${width}px`;
            root.style.height = `${height}px`;
            root.style.overflow = "hidden";
        }
        return () => {
            html.style.overflow = prev.htmlOverflow;
            body.style.overflow = prev.bodyOverflow;
            html.style.width = prev.htmlW;
            html.style.height = prev.htmlH;
            body.style.width = prev.bodyW;
            body.style.height = prev.bodyH;
            body.style.margin = prev.bodyMargin;
            if (root) {
                root.style.width = prev.rootW || "";
                root.style.height = prev.rootH || "";
                root.style.overflow = prev.rootOverflow || "";
            }
        };
    }, [width, height]);
}

export default useCaptureFrameViewport;
